var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { key: _vm.note.id, staticClass: "panel" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c(
          "div",
          { staticClass: "row", staticStyle: { "padding-bottom": "10px" } },
          [
            _c("div", { staticClass: "col-xs-3" }, [
              _vm._v(
                _vm._s(
                  _vm._f("date")(
                    _vm.dateCreated,
                    _vm.$user.date_format_preference
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-3" }, [
              _vm._v(_vm._s(_vm.timeCreated)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-8" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.note.text) } }),
            _c("p", { staticClass: "note-creator" }, [
              _vm._v(_vm._s(_vm.creator)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-4 flex justify-end" },
            [
              !_vm.note.pinned
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { click: _vm.handlePinNote },
                    },
                    [
                      _c("i", { staticClass: "fa fa-thumb-tack" }),
                      _vm._v(" Pin\n          "),
                    ]
                  )
                : _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { click: _vm.handlePinNote },
                    },
                    [
                      _c("i", { staticClass: "fa fa-thumb-tack" }),
                      _vm._v(" Unpin\n          "),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "ladda-button",
                {
                  staticClass: "margin-l-1 btn btn-primary",
                  attrs: { click: _vm.handleDeleteNoteCallback },
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" Delete\n          "),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }